import {
  Category,
  ChartComponent,
  DataLabel,
  Legend,
  SeriesCollectionDirective,
  SeriesDirective,
  StackingColumnSeries,
  Tooltip,
} from '@syncfusion/ej2-react-charts';
import { Inject, SidebarComponent } from '@syncfusion/ej2-react-navigations';
import { GetSchedulerKPI } from '../../services/CloudScheduler/CloudSchedulerServices';
import Message from '../../utils/Message/Message';
import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/theme.context';
import oops from '../../assets/icons/images/oops.png';
import { loadingShow } from '../../App';

interface IProps {
  sidebarOpen: (val: boolean) => void;
  refSide: (ref: SidebarComponent) => void;
  query: string;
}
let sidebarobj: SidebarComponent = new SidebarComponent({});
const SidebarKPI = ({ sidebarOpen, refSide, query }: IProps) => {
  const [graphDataSet, setGraphDataSet] = useState<Array<any>>([]);
  const colors = [
    '#0e66e8',
    '#7aa8e8',
    '#db3016',
    '#30ed13',
    '#696969',
    '#22799c',
    '#db6b16',
    '#81a391',
    '#8216db',
    '#8e18c9',
    '#f2eeb8',
    '#00b6ff',
    '#2a1140',
    '#d736e3',
    '#d1c40f',
    '#a971ad',
    '#6c5f73',
    '#e6e3e8',
    '#f097b0',
    '#73eb89',
  ];
  const generateColor = (index: number) => {
    return colors[index];
  };
  const designedKpiData = (dataSet: any) => {
    let tickectsOfGraph: Array<any> = [];
    let dataOfGraph: Array<any> = [];
    let testData: Array<any> = [];
    var counter: number = 0;
    try {
      dataSet.map((el: any) => {
        let findIndex = testData.findIndex((indexEl) => {
          return el.dayName === indexEl.dayName;
        });
        if (findIndex !== -1) {
          testData[findIndex].capacity =
            testData[findIndex].capacity + el.capacity;
          testData[findIndex].load = testData[findIndex].load + el.load;
          let result =
            Number(testData[findIndex].capacity) -
            Number(testData[findIndex].load);
          if (result > 0) {
            testData[findIndex].type = 'Load';
            testData[findIndex].Y = testData[findIndex].load;

            testData[findIndex + 1].type = 'Remaning';
            testData[findIndex + 1].Y = result;
          } else {
            testData[findIndex].type = 'Overload';
            testData[findIndex].Y = Math.abs(result);

            testData[findIndex + 1].type = 'Load';
            testData[findIndex + 1].Y = Math.abs(testData[findIndex].capacity);
          }
        } else {
          let result = Number(el.capacity) - Number(el.load);
          if (result >= 0) {
            testData.push({
              dayName: el.dayName,
              type: 'Load',
              Y: Math.abs(Number(el.load)),
              capacity: Math.abs(el.capacity),
              load: Math.abs(el.load),
            });
            testData.push({
              dayName: el.dayName,
              type: 'Remaning',
              Y: Math.abs(result),
            });
          } else {
            testData.push({
              dayName: el.dayName,
              type: 'Overload',
              Y: Math.abs(result),
              capacity: Math.abs(el.capacity),
              load: Math.abs(el.load),
            });
            testData.push({
              dayName: el.dayName,
              type: 'Load',
              Y: Math.abs(el.capacity),
            });
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
    dataSet = testData;
    dataSet.forEach((el: any) => {
      const foundIndex = tickectsOfGraph.findIndex((elin) => {
        return elin.value === el.type;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickectsOfGraph.push({
          y: `y${counter}`,
          value: el.type,
          color: generateColor(counter),
        });
        counter++;
      }
    });
    dataSet.forEach((element: any) => {
      const foundIndex = dataOfGraph.findIndex((elin) => {
        return elin.dayName === element.dayName;
      });
      var paramName: any = [];
      paramName = tickectsOfGraph.filter((el) => el.value === element.type);
      if (foundIndex != -1) {
        dataOfGraph[foundIndex][paramName[0].y] = element.Y;
      } else {
        dataOfGraph.push({
          dayName: element.dayName,
          trade_code: element.trade_code,
          [paramName[0].y]: element.Y,
        });
      }
    });

    return { tickets: tickectsOfGraph, data: dataOfGraph };
  };
  const context = useContext(ThemeContext);
  const getKPIData = (rangeLoad: string) => {
    GetSchedulerKPI(rangeLoad)
      .then((result) => {
        loadingShow(false);
        let groupByTrades: any = {};
        result.data.map((el: any) => {
          if (groupByTrades[el.trade_code]) {
            let temp = groupByTrades[el.trade_code];
            if (el.alias_name === 'NS' || el.alias_name === 'FI') {
              temp.NIGHT.push(el);
            } else if (el.alias_name === 'DS' || el.alias_name === 'FO') {
              temp.DAY.push(el);
            }
          } else {
            if (el.alias_name === 'NS' || el.alias_name === 'FI') {
              groupByTrades[el.trade_code] = {
                NIGHT: [{ ...el }],
                DAY: [],
              };
            } else if (el.alias_name === 'DS' || el.alias_name === 'FO') {
              groupByTrades[el.trade_code] = {
                DAY: [{ ...el }],
                NIGHT: [],
              };
            }
          }
        });
        let finalData: any = {};
        let keys = Object.entries(groupByTrades);
        keys.map((el: any) => {
          finalData[el[0]] = {
            name: el[0],
            DAY: designedKpiData(el[1].DAY),
            NIGHT: designedKpiData(el[1].NIGHT),
          };
        });
        setGraphDataSet(Object.entries(finalData));
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Something went wrong!!! Code:1449-CScheduler ');
      });
  };
  useEffect(() => {
    query !== '' && getKPIData(query);
    return () => {};
  }, [query]);

  return (
    <>
      <SidebarComponent
        id='defaultSidebar'
        ref={(Sidebar: SidebarComponent) => {
          sidebarobj = Sidebar;
          refSide && refSide(Sidebar);
        }}
        className='default-sidebar'
        width='480px'
        target='.cloud-scheduler-main-content'
        position='Right'
        created={() => {
          sidebarobj?.toggle();
        }}
        open={() => sidebarOpen(true)}
        close={() => sidebarOpen(false)}
      >
        <div
          style={{
            width: '100%',
            height: '50px',
          }}
        />
        {graphDataSet.length > 0 ? (
          <div>
            <div className='graph-content'>
              <div id='chart2CS'>
                {graphDataSet.length > 0 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[0][0]} (NIGHT)`}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[0][1].NIGHT.tickets.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[0][1].NIGHT.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart1CS'>
                {graphDataSet.length > 0 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[0][0]} (Day)`}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[0][1].DAY?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[0][1].DAY?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart3CS'>
                {graphDataSet.length > 1 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[1][0]} (Night)`}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[1][1].NIGHT?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[1][1].NIGHT?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart4CS'>
                {graphDataSet.length > 1 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    height={'300px'}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[1][0]} (Day)`}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[1][1].DAY?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[1][1].DAY?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart5CS'>
                {graphDataSet.length > 2 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[2][0]} (Night)`}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[2][1].NIGHT?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[2][1].NIGHT?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart6CS'>
                {graphDataSet.length > 2 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[2][0]} (Day)`}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[2][1].DAY?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[2][1].DAY?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart7CS'>
                {graphDataSet.length > 3 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    title={`${graphDataSet[3][0]} (Night)`}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[3][1].NIGHT?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[3][1].NIGHT?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
              <div id='chart8CS'>
                {graphDataSet.length > 3 ? (
                  <ChartComponent
                    style={{ textAlign: 'center' }}
                    primaryXAxis={{
                      valueType: 'Category',
                      labelIntersectAction: 'Rotate45',
                      majorGridLines: { width: 0 },
                      minorGridLines: { width: 0 },
                      majorTickLines: { width: 0 },
                      minorTickLines: { width: 0 },
                    }}
                    width={'100%'}
                    height={'300px'}
                    background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                    chartArea={{ border: { width: 0 } }}
                    titleStyle={{
                      color: context.isDarkMode ? 'white' : 'black',
                    }}
                    title={`${graphDataSet[3][0]} (Day)`}
                    tooltip={{
                      enable: true,
                      format:
                        '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                    }}
                    legendSettings={{
                      textStyle: {
                        color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                        size: '8px',
                      },
                      position: 'Top',
                    }}
                  >
                    <Inject
                      services={[
                        StackingColumnSeries,
                        Legend,
                        Tooltip,
                        DataLabel,
                        Category,
                      ]}
                    />
                    <SeriesCollectionDirective>
                      {graphDataSet[3][1].DAY?.tickets?.map(
                        (el: any, index: number) => {
                          return (
                            <SeriesDirective
                              key={Math.random()}
                              dataSource={graphDataSet[3][1].DAY?.data}
                              xName='dayName'
                              yName={`y${index}`}
                              name={el.value}
                              type='StackingColumn'
                              fill={el.color}
                            ></SeriesDirective>
                          );
                        }
                      )}
                    </SeriesCollectionDirective>
                  </ChartComponent>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <div className='cloud-scheduler-no-data'>
            <img
              className='cloud-schedule-img'
              src={oops}
              alt='oops'
              width={'200px'}
              height={'200px'}
              color={'#ffff'}
            />
            <span>No data to show</span>
          </div>
        )}
      </SidebarComponent>
    </>
  );
};
export default SidebarKPI;
